export enum SORT_TYPE {
    ASC = 'asc',
    DESC = 'desc'
}